import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Pill from 'srcReact/components/common2/Pill'
import styles from './styles.module.scss'

export default function InterestsBlock() {
  const { t } = useTranslation()
  const { profileData } = useSelector((state) => state.myProfile)
  const { isMobile } = useSelector((state) => state.common)

  const getInterestValue = (interest) => {
    switch (interest.type) {
      case 'children':
        return interest.value > 1
          ? interest.value + ' ' + t(`my_profile.interests.pill_children`)
          : interest.value + ' ' + t(`my_profile.interests.pill_child`)
      default:
        return interest.value
    }
  }

  return (
    profileData.random_matches &&
    profileData.random_matches.length >= 1 && (
      <div className={`${styles.interestContainer}`}>
        <div className={styles.interestsWrapper}>
          {profileData.random_matches.map((interest, idx) => (
            <div className={styles.interest} key={idx}>
              <h2>{t(`my_profile.interests.${[interest.type]}`)}</h2>
              <Pill
                className={styles.pill}
                showIcon={false}
                shared={true}
                dataId={interest.value}
                text={getInterestValue(interest)}
                size='medium'
              />
            </div>
          ))}
        </div>
      </div>
    )
  )
}
